import Vue from 'vue'
import axios from 'axios'
axios.interceptors.request.use(config => {
  return config;
}, function (error) {
  return Promise.reject(error);
});
export default axios



// WEBPACK FOOTER //
// ./src/api/http.js